import React from 'react';

interface HeadsetIconProps {
  size?: number;
  className?: string;
}

const HeadsetIcon: React.FC<HeadsetIconProps> = ({ size = 18, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_iii_4611_3004)">
        <path d="M16.1401 8.48878V13.5967C16.1401 14.2741 15.871 14.9237 15.392 15.4027C14.9131 15.8816 14.2635 16.1507 13.5861 16.1507H10.0105C9.87506 16.1507 9.74513 16.0969 9.64934 16.0011C9.55355 15.9053 9.49973 15.7754 9.49973 15.6399C9.49973 15.5045 9.55355 15.3745 9.64934 15.2787C9.74513 15.1829 9.87506 15.1291 10.0105 15.1291H13.5861C13.9925 15.1291 14.3823 14.9677 14.6697 14.6803C14.957 14.3929 15.1185 14.0032 15.1185 13.5967H13.5861C13.1797 13.5967 12.7899 13.4353 12.5025 13.1479C12.2152 12.8605 12.0537 12.4708 12.0537 12.0644V9.51037C12.0537 9.10396 12.2152 8.71419 12.5025 8.42681C12.7899 8.13943 13.1797 7.97798 13.5861 7.97798H15.0961C14.9995 6.91612 14.6027 5.90369 13.9521 5.05893C13.3015 4.21418 12.424 3.57198 11.422 3.20735C10.42 2.84272 9.335 2.77071 8.29364 2.99974C7.25228 3.22876 6.29758 3.74936 5.54106 4.50073C4.60033 5.42905 4.02011 6.66146 3.90395 7.97798H5.41336C5.81977 7.97798 6.20954 8.13943 6.49692 8.42681C6.7843 8.71419 6.94575 9.10396 6.94575 9.51037V12.0644C6.94575 12.4708 6.7843 12.8605 6.49692 13.1479C6.20954 13.4353 5.81977 13.5967 5.41336 13.5967H4.39176C3.98535 13.5967 3.59558 13.4353 3.3082 13.1479C3.02082 12.8605 2.85938 12.4708 2.85938 12.0644V8.48878C2.86081 7.17341 3.25245 5.88804 3.98473 4.79535C4.717 3.70267 5.757 2.8518 6.97307 2.35044C8.18914 1.84908 9.52662 1.71977 10.8162 1.97889C12.1058 2.238 13.2895 2.87388 14.2176 3.80605C14.8303 4.42176 15.3155 5.15231 15.6454 5.95586C15.9753 6.75941 16.1434 7.62015 16.1401 8.48878Z" fill="#888888"/>
      </g>
      <defs>
        <filter id="filter0_iii_4611_3004" x="2.0514" y="1.84863" width="16.7435" height="16.3018" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="0.577124"/>
          <feGaussianBlur stdDeviation="0.577124"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4611_3004"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="3" dy="2"/>
          <feGaussianBlur stdDeviation="1.32739"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="effect1_innerShadow_4611_3004" result="effect2_innerShadow_4611_3004"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-0.807974" dy="0.23085"/>
          <feGaussianBlur stdDeviation="0.461699"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"/>
          <feBlend mode="normal" in2="effect2_innerShadow_4611_3004" result="effect3_innerShadow_4611_3004"/>
        </filter>
      </defs>
    </svg>
  );
};

export default HeadsetIcon;